import * as React from "react"
import CvButton from "./cvbutton"

import cvImg from "../images/image-cv-web.png"
import cvImgx2 from "../images/image-cv-web@2x.png"
import cv_sp from "../images/image-cv_sp.png"
import cv_spx2 from "../images/image-cv_sp@2x.png"

export const CvButtons = ({ children }) => {
  return (
    <ul className="cv__btm">
      { children }
      <li className="cv__btm_item">
        <CvButton
          primaryLabel="今すぐ無料ではじめる"
          Color="Red"
          href="/get-started"
          secondaryLabel="1分で完了！カンタンお申し込み"
        />
      </li>
      <li className="cv__btm_item">
        <CvButton
          primaryLabel="資料ダウンロード"
          Color="Navy"
          href="/download"
          secondaryLabel="売上安定・拡大の秘訣がここに！"
        />
      </li>
    </ul>
  )
}

const Cv = () => {
  return (
    <div className="cv">
      <div className="container">
        <div className="cv__box">
          <div className="cv__infos">
            <h2 className="cv__ttl">
              フードデリバリーで
              <br />
              ビジネスを拡大
            </h2>
            <p className="cv__desc">
              11万店舗以上が加盟する日本最大級の
              <br className="u-sp-hidden" />
              デリバリーサービス出前館と共に
              <br className="u-sp-hidden" />
              今すぐフードデリバリーを無料ではじめましょう
            </p>
          </div>
          <picture className="cv__pc">
            <source
              media="(max-width: 767px)"
              type="image/png"
              src={cv_sp}
              srcset={`${cv_sp} 1x, ${cv_spx2} 2x`}
            />
            <img
              src={cvImg}
              srcset={`${cvImg} 1x, ${cvImgx2} 2x`}
              alt="出前館モックアップ"
            />
          </picture>
        </div>
        {/* cv__box */}

        <CvButtons />
      </div>
      {/* container */}
    </div>
  )
}

export default Cv
